<template>
  <div class="def-social">
    <a
      v-for="(service, key) in socialServices"
      :key="key"
      :href="service.href"
      rel="nofollow"
      target="_blank"
      class="def-social__item"
    >
      <svg class="def-social__icon"><use :xlink:href="`#svg-${key}`"></use></svg>
    </a>
  </div>
</template>

<script lang="ts" setup>
import { useResultsStore } from '@/storePinia/stores/results';
import { storeToRefs } from 'pinia';

const { socialServices } = storeToRefs(useResultsStore());
</script>

<style lang="scss" scoped>
.def-social {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  &__item {
    display: inline-flex;
    &:hover {
      .def-social__icon {
        fill: var(--color-link-hover-dark);
        transform: scale(1.1);
      }
    }
  }
  &__icon {
    display: inline-block;
    height: 24px;
    width: 24px;
    fill: var(--background-black);
    transition: 0.2s linear fill, 0.2s linear transform;
  }
}
</style>
